import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { catchError, map, tap, throwError } from 'rxjs';
import { AuthModel } from './models/version-2/auth.model-verssion2';
import { ILoginByGoogle } from './models/login-3th.interface';
import { AuthErrorModel } from './models/version-2/auth-error-version2.model';
import { AuthService } from './auth-version-2.service';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { URI_APIs } from '@features/auth/const';
import { StorageHelper } from '@features/auth/shared/helpers/storage.helper';
@Injectable()
export class LoginByGoogleService implements ILoginByGoogle {
  public httpClient = inject(HttpClient);
  public authService = inject(AuthService);
  conf = inject(CoreAuthConfigService);

  constructor() {}

  googleAuth(accessToken: string) {
    const requestBody = {
      access_token: accessToken,
    };

    return this.httpClient
      .post(this.conf.buildURL(URI_APIs.GOOGLE_END_ACCESS_TOKEN_ENDPOINT), requestBody, {
        headers: {
          use_appkey: "true",
        }
      })
      .pipe(
        catchError((err) => {
          return throwError(() => AuthErrorModel.handle(err));
        }),
        map((response: any) => {
          return new AuthModel().fromLoginByGmailResponse(response);
        }),
      // TODO: Logic nay viet trog fromLoginByGmailResponse
        tap((formated) => {
          let listmenu: any[] = [];
          if (Array.isArray(formated.old_login_info.listmenu_active)) {
            listmenu = [...formated.listmenu_active, ...formated.old_login_info.listmenu_active];
          }
          this.authService.setAuthResponseToStorage(
            formated.token,
            formated.result,
            listmenu,
          );
        }),
        tap((res) => {
          StorageHelper.saveOldAccessToken(res.getOldAccessToken());
        })
      );
  }
}
